// @ts-check
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import api from 'modules/queries/api';

const useServerWhmFirewallUnblockip = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/server/whm/firewall/index.raw').LWApiPublicServerWhmFirewallUnblockipParamsRaw} params */
			(params) => api.server.whm.firewall.apiRaw.unblockip(params),

		onSuccess: (data, params) => {
			queryClient.invalidateQueries({
				queryKey: ['/asset/details', { uniq_id: params.uniq_id }],
			});
		},

		onError: snackbarError,
	});
};

export default useServerWhmFirewallUnblockip;
